import type { ContentPickerPaneProps } from "./components/ContentPickerPane";
import type * as lazyIndex from "./lazyIndex";
import { LazyAction, type LazyComponent, LazyModule, createLazyComponent } from "owa-bundling";

const lazyModule: LazyModule<typeof lazyIndex> = new LazyModule<typeof lazyIndex>(() => import(/* webpackChunkName: "EditorContentPicker" */ "./lazyIndex"), { name: "EditorContentPicker" });

export const lazyToggleContentPickerPane: LazyAction<typeof lazyIndex.toggleContentPickerPane, typeof lazyModule> = new LazyAction(lazyModule, m => m.toggleContentPickerPane);

export const lazyCloseContentPickerPane: LazyAction<typeof lazyIndex.closeContentPicker, typeof lazyModule> = new LazyAction(lazyModule, m => m.closeContentPicker);

export const lazyDismissGraphicsPane: LazyAction<typeof lazyIndex.dismissGraphicsPane, typeof lazyModule> = new LazyAction(lazyModule, m => m.dismissGraphicsPane);

export const lazyInsertTextIntoEditor: LazyAction<typeof lazyIndex.insertTextIntoEditor, typeof lazyModule> = new LazyAction(lazyModule, m => m.insertTextIntoEditor);

export const ContentPickerPane: LazyComponent<ContentPickerPaneProps, unknown, void> = createLazyComponent(lazyModule, m => m.ContentPickerPane);
export const GraphicsPane: LazyComponent<unknown, void> = createLazyComponent(lazyModule, m => m.GraphicsPane);
